(() => {
  if (window.__bookYorkNativeReviewsLoaded) return;
  window.__bookYorkNativeReviewsLoaded = true;

  const escapeHtml = (value) => {
    const node = document.createElement('div');
    node.textContent = String(value ?? '');
    return node.innerHTML;
  };

  const stars = (value) => {
    const count = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
    return `${'★'.repeat(count)}${'☆'.repeat(5 - count)}`;
  };

  const formatMonthYear = (value) => {
    if (!value) return '';
    const date = new Date(`${String(value).slice(0, 10)}T12:00:00Z`);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('en-GB', {
      month: 'long',
      year: 'numeric',
      timeZone: 'UTC'
    }).format(date);
  };

  const reviewMarkup = (review) => {
    const rating = Math.max(0, Math.min(5, Math.round(Number(review?.stars) || 0)));
    const body = String(review?.body || '');
    const collapsible = body.length > 520;
    const displayName = String(review?.display_name || '').trim() || 'Guest';
    const source = String(review?.listing_site || '').trim();
    const date = String(review?.date || '').slice(0, 10);
    const title = String(review?.title || '').trim();

    return `
      <article class="book-york-review">
        <div class="book-york-review__topline">
          <span class="book-york-review__stars" aria-label="${rating} out of 5 stars">
            <span aria-hidden="true">${stars(rating)}</span>
          </span>
          ${source ? `<span class="book-york-review__source">${escapeHtml(source)}</span>` : ''}
        </div>
        ${title ? `<h3 class="book-york-review__title">${escapeHtml(title)}</h3>` : ''}
        ${body ? `
          <div class="book-york-review__body${collapsible ? ' is-collapsible' : ''}" data-review-body>${escapeHtml(body).replace(/\r?\n/g, '<br>')}</div>
          ${collapsible ? '<button type="button" class="book-york-review__more" data-review-more aria-expanded="false">Read more</button>' : ''}
        ` : ''}
        <footer class="book-york-review__meta">
          <span>${escapeHtml(displayName)}</span>
          ${date ? `<span><time datetime="${escapeHtml(date)}">${escapeHtml(formatMonthYear(date))}</time></span>` : ''}
        </footer>
      </article>
    `;
  };

  const bindReadMore = (root) => {
    root.querySelectorAll('[data-review-more]').forEach((button) => {
      if (button.dataset.bound === '1') return;
      button.dataset.bound = '1';
      button.addEventListener('click', () => {
        const body = button.previousElementSibling;
        if (!body?.matches('[data-review-body]')) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        body.classList.toggle('is-expanded', !expanded);
        button.textContent = expanded ? 'Read more' : 'Show less';
      });
    });
  };

  document.querySelectorAll('[data-book-york-reviews]').forEach((root) => {
    if (root.dataset.bound === '1') return;
    root.dataset.bound = '1';

    const jsonNode = root.querySelector('[data-review-json]');
    const list = root.querySelector('[data-review-list]');
    const previous = root.querySelector('[data-review-prev]');
    const next = root.querySelector('[data-review-next]');
    const status = root.querySelector('[data-review-status]');
    const pageSize = Math.max(1, Number(root.dataset.pageSize) || 3);

    let payload = {};
    try {
      payload = JSON.parse(jsonNode?.textContent || '{}');
    } catch (error) {
      console.error('Book York reviews: invalid embedded review data.', error);
    }

    const reviews = Array.isArray(payload?.items) ? payload.items : [];
    const totalPages = Math.max(1, Math.ceil(reviews.length / pageSize));
    let page = 1;

    const renderPage = (targetPage, scroll = true) => {
      if (!list || !reviews.length) return;
      page = Math.max(1, Math.min(totalPages, targetPage));
      const start = (page - 1) * pageSize;
      list.innerHTML = reviews.slice(start, start + pageSize).map(reviewMarkup).join('');

      if (previous) previous.disabled = page <= 1;
      if (next) next.disabled = page >= totalPages;
      if (status) status.textContent = `${page} of ${totalPages}`;

      bindReadMore(list);

      if (scroll) {
        root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    };

    previous?.addEventListener('click', () => renderPage(page - 1));
    next?.addEventListener('click', () => renderPage(page + 1));

    bindReadMore(root);

    if (previous) previous.disabled = true;
    if (next) next.disabled = totalPages <= 1;
    if (status) status.textContent = `1 of ${totalPages}`;
  });
})();
